// Whitelist of authorized admin email addresses
// Only these users can access the admin panel

export const ADMIN_EMAILS = [
  'preritaggarwal66@gmail.com',
  'tusharjaintj2002@gmail.com',
];

// Helper function to check if an email is an admin
export const isAdminEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};

// Export for Firestore rules documentation
export const getFirestoreAdminEmails = (): string => {
  return ADMIN_EMAILS.map((email) => `'${email}'`).join(', ');
};
